import React, { useState } from 'react';
import { Alert, Link, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import RejectionModal from '../../../NewIntervention/Steps/PDSSelection/RejectionModal';
import { useInterventionCreation } from '../../context/interventionCreationContext';
import { duplicateRejections } from './pdsImport';

export default function ImportReportBanner() {
  const { t } = useTranslation();
  const { state, dispatch } = useInterventionCreation();
  const [rejectionsOpen, setRejectionsOpen] = useState(false);

  const report = state.lastImportReport;

  if (report === null) {
    return null;
  }

  // Les doublons rejoignent les rejets, et se rangent après eux : eux seuls sont dépourvus de
  // numéro de ligne, et les cellules vides forment ainsi un bloc plutôt que des trous au milieu
  // d'une colonne numérotée. Volontairement pas mémoïsé : figée sur le rapport, la liste
  // garderait la langue en vigueur au moment de l'import.
  const rejections = [
    ...report.rejections,
    ...duplicateRejections(
      report.duplicates,
      t('interventionCreation.requests.importReport.duplicateReason')
    )
  ];

  return (
    <>
      <Alert
        // Un doublon est une ligne non ajoutée : il appelle le même regard qu'une ligne en erreur.
        severity={report.invalidCount > 0 || report.duplicateCount > 0 ? 'warning' : 'success'}
        closeText={t('close')}
        onClose={() => dispatch({ type: 'dismissImportReport' })}
      >
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Typography variant="body2">
            {report.fileName
              ? t('interventionCreation.requests.importReport.fromFile', {
                  name: report.fileName,
                  count: report.addedCount
                })
              : t('interventionCreation.requests.importReport.added', {
                  count: report.addedCount
                })}
          </Typography>
          {report.duplicateCount > 0 && (
            <Typography variant="body2">
              {t('interventionCreation.requests.importReport.duplicates', {
                count: report.duplicateCount
              })}
            </Typography>
          )}
          {report.invalidCount > 0 && (
            <Typography variant="body2">
              {t('interventionCreation.requests.importReport.invalid', {
                total: report.invalidCount
              })}
            </Typography>
          )}
          {rejections.length > 0 && (
            <Link component="button" type="button" onClick={() => setRejectionsOpen(true)}>
              {t('interventionCreation.requests.importReport.seeErrors', {
                total: rejections.length
              })}
            </Link>
          )}
        </Stack>
      </Alert>

      <RejectionModal
        open={rejectionsOpen}
        invalidData={rejections}
        onClose={() => setRejectionsOpen(false)}
      />
    </>
  );
}
